const mocks = {
  auth: { 
    POST: [

      // аккаунты 

      { 
        token: "This-is-a-mocked-token",
        username: '9055',
        user_pass: 'lkgjsof',
        status: '20',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'manufacturing_man',
        user_pass: 'gh7kd23',
        status: '23',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'admin_man',
        user_pass: 'dasdg214',
        status: '966',
      },
       { 
        token: "This-is-a-mocked-token",
        username: 'manuf',
        user_pass: '155',
        status: '666',
      },
      

// дизайнеры

      { 
        token: "This-is-a-mocked-token",
        username: 'Azura',
        user_pass: 'Daedr1c',
        status: '1660543483156 , 1611298923259',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'Farida_Siraeva',
        user_pass: 'Kj01JdaQ',
        status: '1653653337197',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'faina',
        user_pass: 'j14heArt',
        status: '1644848510234',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'dima',
        user_pass: '1947saf',
        status: '1625815081116',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'Chivieva_Alexandra',
        user_pass: 'fdgh452',
        status: '1613570822840 , 1622560085305',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'Наталья Колмакова',
        user_pass: 'BV88Ja',
        status: '1706799430646',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'sophiHH',
        user_pass: 'sfd14145',
        status: '1611298923259 , 1660543483156',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'Maxim',
        user_pass: 'KJ18aPk',
        status: '1693906709344',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'Olesya',
        user_pass: 'Ja092Lfk',
        status: '1644838621083',
      },
      // { 
      //   token: "This-is-a-mocked-token",
      //   username: 'Полина Лепкова',
      //   user_pass: 'kdA1eq2',
      //   status: '1622560085305',
      // },
      { 
        token: "This-is-a-mocked-token",
        username: 'Виктория Санторская',
        user_pass: 'Lop89Ja',
        status: '1697613289809',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'Алёна Зелинская',
        user_pass: 'Uuh954A',
        status: '1726060810750',
      },
      
      { 
        token: "This-is-a-mocked-token",
        username: 'Мария Скворцова',
        user_pass: '85Q4k7',
        status: '1730468769784',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'Елена Кудрявцева',
        user_pass: 'HAABt1',
        status: '1727108996550 , 1749058962574',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'Полина Лепкова',
        user_pass: 'nQ1fph',
        status: '1622560085305 , 1613570822840',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'Гюнель',
        user_pass: 'jf65RT',
        status: '1694883137051',
      },
    
      { 
        token: "This-is-a-mocked-token",
        username: 'Анна Заднепровская',
        user_pass: 'ksA89Pj',
        status: '1706861422357 , 1706861416463',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'Лолита',
        user_pass: 'Unz44Ya',
        status: '1706861416463 , 1706861422357',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'Дорошенко Екатерина',
        user_pass: 'AAm667',
        status: '1709295384179',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'Александр Катаев',
        user_pass: '554YtN',
        status: '1713279326086',
      },
      // { 
      //   token: "This-is-a-mocked-token",
      //   username: 'Иванченко Екатерина',
      //   user_pass: 'kd99Jui',
      //   status: '1713279358769 , 1720862536119',
      // },
      // { 
      //   token: "This-is-a-mocked-token",
      //   username: 'Александра Грызова',
      //   user_pass: '19KyRRf',
      //   status: '1715618977060 , 1720862536119',
      // },
      { 
        token: "This-is-a-mocked-token",
        username: 'Бартенева Анна',
        user_pass: 'ka990Kj',
        status: '1716903108552',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'Водолазская Юлия',
        user_pass: 'pD91Ja',
        status: '1717074524720',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'Даша Холодкова',
        user_pass: 'ks017AD',
        status: '1694883142326',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'Александра Павлова',
        user_pass: 'uy7326Qer',
        status: '1720862536119 , 1713279358769 , 1740084662255',
      },
      // { 
      //   token: "This-is-a-mocked-token",
      //   username: 'Ирина Крылова',
      //   user_pass: 'amO8s11',
      //   status: '1721201198827 , 1738776488064',
      // },
      { 
        token: "This-is-a-mocked-token",
        username: 'Колесова Анна',
        user_pass: 'NwA246a',
        status: '1721218523154',
      }, 
      { 
        token: "This-is-a-mocked-token",
        username: 'Оксана Пономарёва',
        user_pass: 'mLn6Gd',
        status: '1737626956732 , 1737393880879',
      }, 
      { 
        token: "This-is-a-mocked-token",
        username: 'Жанна Демидова',
        user_pass: 'ab3kKV',
        status: '1737483939498',
      }, 
      { 
        token: "This-is-a-mocked-token",
        username: 'Анастасия Гаврилова',
        user_pass: 'VmJHr7',
        status: '1737393880879 , 1737626956732',
      }, 
      { 
        token: "This-is-a-mocked-token",
        username: 'Даниил Кудряшов',
        user_pass: '4tFrsO',
        status: '1738519113492 , 1730468769784',
      }, 
      { 
        token: "This-is-a-mocked-token",
        username: 'Анастасия Ткачёва',
        user_pass: 'HJnsM3',
        status: '1739984217360 , 1740903583608',
      }, 
      { 
        token: "This-is-a-mocked-token",
        username: 'Лидия Федорова',
        user_pass: 'NqFZP1',
        status: '1740084662255',
      }, 
    
      { 
        token: "This-is-a-mocked-token",
        username: 'Алина Калашникова',
        user_pass: '5xrRiF',
        status: '1741845948371',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'Мария Абрамова',
        user_pass: 'V1PCNd',
        status: '1740903583608 , 1739984217360',
      }, 
      { 
        token: "This-is-a-mocked-token",
        username: 'Вероника Лещенко',
        user_pass: 'i9KC3A',
        status: '1740762935472',
      }, 
      { 
        token: "This-is-a-mocked-token",
        username: 'Виктория Дадина',
        user_pass: 'N92PGv',
        status: '1741845954723 , 1745775781343',
      }, 
      { 
        token: "This-is-a-mocked-token",
        username: 'Альбина Дорофеева',
        user_pass: 'V3w6xh',
        status: '1745775781343 , 1741845954723',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'Кольцова Карина',
        user_pass: '32GDy3',
        status: '1749058962574 , 1727108996550',
      },
        { 
        token: "This-is-a-mocked-token",
        username: 'Алия Ким',
        user_pass: 'g7fUvf',
        status: '1750407361885 , 1752663018582',
      },
         { 
        token: "This-is-a-mocked-token",
        username: 'Маргарита Дафнева',
        user_pass: 'QRyzJl',
        status: '1752774567315',
      },
         { 
        token: "This-is-a-mocked-token",
        username: 'Людмила Стребкова',
        user_pass: '4a6wbg',
        status: '1753078510772',
      }, { 
        token: "This-is-a-mocked-token",
        username: 'Юлиана Агафонова',
        user_pass: '8Nqzxs',
        status: '1752851231384 , 1752663012110',
      },
       { 
        token: "This-is-a-mocked-token",
        username: 'Ирина Овчиникова',
        user_pass: '1jZ9Af',
        status: '1752663018582 , 1750407361885',
      },
         { 
        token: "This-is-a-mocked-token",
        username: 'Катерина Холина',
        user_pass: 'KfZf5i',
        status: '1752663012110 , 1752851231384',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'София Асафова',
        user_pass: 'duB3d',
        status: '1755670848999',
      },
       { 
        token: "This-is-a-mocked-token",
        username: 'Вероника Ющенко',
        user_pass: '3i54AD',
        status: '1757744347368',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'Софья Абишева',
        user_pass: 'm4ur96',
        status: '1738776488064 , 1758300749165',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'Елфимчева Екатерина',
        user_pass: 'kiK8g5',
        status: '1758300749165 , 1738776488064',
      },
       { 
        token: "This-is-a-mocked-token",
        username: 'Жаркова Анна',
        user_pass: 'Xafp_7',
        status: '1760780537262 , 1766313130191',
      },
       { 
        token: "This-is-a-mocked-token",
        username: 'Маргарита Григорьева',
        user_pass: '3pteHZ',
        status: '1757744307561 , 1763629993749',
      },
      { 
        token: "This-is-a-mocked-token",
        username: 'Наталия Чистосердова',
        user_pass: '8uY_kh',
        status: '1763629993749 , 1757744307561',
      },
      // { 
      //   token: "This-is-a-mocked-token",
      //   username: 'Карина Крохина',
      //   user_pass: 'X-N2hZ',
      //   status: '1762862414606 , 1763629993749',
      // },
      //            { 
      //   token: "This-is-a-mocked-token",
      //   username: 'Агеева Ангелина',
      //   user_pass: 'v_A6yX',
      //   status: '1765962363730 , 1757744307561',
      // },
       { 
        token: "This-is-a-mocked-token",
        username: 'Анастасия Бучина',
        user_pass: 'nLE5-X',
        status: '1763663762363 , 1763663783307',
      },
        { 
        token: "This-is-a-mocked-token",
        username: 'Александра Лекомцева',
        user_pass: 'sq_6QT',
        status: '1763663783307 , 1763663762363',
      },
        { 
        token: "This-is-a-mocked-token",
        username: 'Анна Макина',
        user_pass: 'ZCe_V7',
        status: '1764957637527 , 1764867813849',
      },
         { 
        token: "This-is-a-mocked-token",
        username: 'Анастасия Азарова',
        user_pass: 'p2P-0N',
        status: '1764867813849 , 1764957637527',
      },
         { 
        token: "This-is-a-mocked-token",
        username: 'Ренат Салахутдинов',
        user_pass: 'pNr4-W',
        status: '1764957664648 , 1765559042318',
      },

      
       { 
        token: "This-is-a-mocked-token",
        username: 'Молоканова Марина',
        user_pass: '2_Armc',
        status: '1765439335360 , 1765038298685',
      },
       { 
        token: "This-is-a-mocked-token",
        username: 'Ольга Костюкевич',
        user_pass: '5-a12E',
        status: '1765038298685 , 1765439335360',
      },
         { 
        token: "This-is-a-mocked-token",
        username: 'Телятников Леон',
        user_pass: 'p3_X6i',
        status: '1765559042318 , 1764957664648',
      },

          { 
        token: "This-is-a-mocked-token",
        username: 'Анна Крутикова',
        user_pass: 'H2Gof_',
        status: '1766313130191 , 1760780537262',
      },
          { 
        token: "This-is-a-mocked-token",
        username: 'Заева Вероника',
        user_pass: 'p6_FdE',
        status: '1766649015389 , 1771226277717',
      },
          { 
        token: "This-is-a-mocked-token",
        username: 'Валерия Новоселецкая',
        user_pass: '_f2A$5',
        status: '1771226277717 , 1766649015389',
      },
      
     
   
     
    
    ] 
  },
  "user/me": { GET: { 
      username: 'test',
      user_pass: 'test',
    },
  }
};
  
const apiCall = ({ url, data = null, method = 'GET'}) =>
  new Promise((resolve, reject) => {

    setTimeout(() => {
      try {
        if (method == 'GET') {
          resolve(mocks[url][method]);
        }
        for (let i = 0, l = mocks[url][method].length; i < l; i++) {
          if (mocks[url][method][i].username == data.username && mocks[url][method][i].user_pass == data.password
          ) {
            resolve(mocks[url][method][i]);
          } 
        }
      } catch (err) {
        reject(new Error(err));
      }
    }, 1000);
  });
  
  export default apiCall;